import { DomainRegistry } from '@/creditflowresearch/domain';
import type { IDomainDictionaries } from '@/creditflowresearch/domain';
import { Container } from 'inversify';

interface IProps {
  container: Container,
  domainDictionaries?: IDomainDictionaries,
  children: React.ReactNode,
}

export const DomainRegistryProvider = ({ container, domainDictionaries, children }: IProps) => {
  if (container) {
    if (domainDictionaries) {
      DomainRegistry.initialize(container, domainDictionaries);
    } else {
      DomainRegistry.initialize(container);
    }
  }

  return <>{ children }</>;
};
